import morphdom from "morphdom";

let productRequestGeneration = 0;

class PdpVariantButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.linkEl = this.closest("[data-variant-link]");

    if (!this.linkEl) return;

    this.handleLinkClick = (e) => {
      e.preventDefault();
      this.selectVariant();
    };

    this.linkEl.addEventListener("click", this.handleLinkClick);
  }

  disconnectedCallback() {
    this.linkEl?.removeEventListener("click", this.handleLinkClick);
  }

  async selectVariant() {
    const requestGeneration = ++productRequestGeneration;
    const url = new URL(
      this.getAttribute("product-url"),
      window.location.origin,
    );
    const targetSelector = "#MainContent";

    try {
      const response = await fetch(url);
      if (requestGeneration !== productRequestGeneration || !this.isConnected) {
        return;
      }
      if (!response.ok) {
        throw new Error(`Product request failed: ${response.status}`);
      }

      const text = await response.text();
      if (requestGeneration !== productRequestGeneration || !this.isConnected) {
        return;
      }
      const section = new DOMParser().parseFromString(text, "text/html");
      const sourceTarget = section.querySelector(targetSelector);
      const currentTarget = this.closest(targetSelector);

      if (!sourceTarget || !currentTarget) {
        throw new Error("Product content missing");
      }

      const targetEl = document
        .createRange()
        .createContextualFragment(sourceTarget.outerHTML);

      const updateElAttributes = (fromEl, toEl) => {
        fromEl.dataset.attributesOnly.split(",").forEach((attribute) => {
          if (!attribute) return;
          fromEl.setAttribute(attribute, toEl.getAttribute(attribute));
        });
      };

      morphdom(currentTarget, targetEl, {
        onBeforeElUpdated: (fromEl, toEl) => {
          if (
            "partialMorph" in fromEl.dataset ||
            "partialMorph" in toEl.dataset
          ) {
            fromEl.querySelectorAll("[data-update]").forEach((updateEl) => {
              const replacement = toEl.querySelector(
                `[data-update="${updateEl.dataset.update}"]`,
              );
              if (replacement) updateEl.innerHTML = replacement.innerHTML;
            });

            fromEl
              .querySelectorAll("[data-attributes-only]")
              .forEach((attributesEl) => {
                const toAttributesEl = toEl.querySelector(
                  `#${attributesEl.id}`,
                );
                if (toAttributesEl) {
                  updateElAttributes(attributesEl, toAttributesEl);
                }
              });
            return false;
          }

          if (
            "forceUpdate" in fromEl.dataset ||
            "forceUpdate" in toEl.dataset
          ) {
            fromEl.replaceWith(toEl);
            return false;
          }

          if ("attributesOnly" in fromEl.dataset) {
            updateElAttributes(fromEl, toEl);
            return false;
          }
        },
      });

      if (!window.Shopify.designMode && this.updateUrl) {
        url.searchParams.delete("section_id");
        window.history.replaceState("", "", url);
      }

      document
        .querySelector("#MainContent product-form-selectors")
        ?.dispatchEvent(
          new CustomEvent("pdp-variant-button:updated", { bubbles: true }),
        );
    } catch (error) {
      if (requestGeneration !== productRequestGeneration || !this.isConnected) {
        return;
      }
      console.error(error);
      window.location.assign(url.href);
    }
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }
}

if (!customElements.get("pdp-variant-button")) {
  customElements.define("pdp-variant-button", PdpVariantButton);
}
